<script lang="ts">
    import { fly, fade } from "svelte/transition";

    import {
        currentFrameDetection,
        selectedTrackId,
        currentSegmentIdx,
    } from "../stores/segment";
    import { seeking } from "../stores/player";
    import { players } from "../constants/players";
    import { mugshotSrc } from "../utils/utils";
    import { segments } from "../constants/segments";

    let bboxes: {
        [track_id: string]: [number, number, number, number];
    };
    let currentTrackId: string | null = null;
    let bettingTrackId: string | null = null;
    let domRect: DOMRect | null = null;

    const reset = (): void => {
        $selectedTrackId = null;
        currentTrackId = null;
        domRect = null;
        bboxes = undefined;
        bettingTrackId = null;
    };

    $: {
        if ($currentFrameDetection === undefined) reset();
        else bboxes = $currentFrameDetection.bboxes;

        if ($seeking) reset();
    }
    const onMouseEnter = (trackId: string) => {
        currentTrackId = trackId;
    };

    const onMouseLeave = () => {
        currentTrackId = null;
    };

    const onPlayerClick = (event: MouseEvent, trackId: string | null) => {
        const element = event.target as SVGGraphicsElement;
        if ($selectedTrackId === trackId || trackId === null) {
            $selectedTrackId = null;
            domRect = null;
            // search for overlapped players
            // if (element.nodeName === "rect") {
            //     const bbox = element.getBBox();
            //     const otherPlayerIds = Object.entries(
            //         $currentFrameDetection.bboxes
            //     )
            //         .filter((p) => {
            //             if (trackId === p[0]) return false;
            //             if (p[1][0] >= bbox.x + bbox.width || bbox.x >= p[1][2])
            //                 return false;
            //             if (
            //                 p[1][1] <= bbox.y + bbox.height ||
            //                 bbox.y <= p[1][3]
            //             ) {
            //                 if (p[0] === "00-0035683") {
            //                     console.log(
            //                         `${p[1][1]} <= ${bbox.y + bbox.height}`
            //                     );
            //                     console.log(`${bbox.y} <= ${p[1][3]}`);
            //                 }
            //                 return false;
            //             }
            //             return true;
            //         })
            //         .map((p) => p[0]);
            //     if (otherPlayerIds.length > 0) {
            //         console.log(otherPlayerIds);
            //     }
            // }
        } else {
            $selectedTrackId = trackId;
            if (element.nodeName === "rect") {
                domRect = element.getBoundingClientRect();
            }
            event.stopPropagation();
        }
    };

    const onBetClick = (trackId: string) => {
        bettingTrackId = trackId;
        $selectedTrackId = null;
        domRect = null;
    };

    const tooltipMughostSrc = (trackId: string | null): string => {
        if (trackId === null) return "./images/mugshots/unknown.png";
        return mugshotSrc(players[trackId]);
    };

    const tooltipPlayerName = (trackId: string | null): string => {
        if (trackId === null) return "";
        else
            return `${players[$selectedTrackId].lastname} ${players[$selectedTrackId].firstname[0]}.`;
    };

    const tooltipMarket = (trackId: string | null): string => {
        if (trackId === null) return "";
        else if (
            segments[$currentSegmentIdx].offence_team === players[trackId].team
        )
            return "Next Play Receiver";
        else return "Next Play Intercepter";
    };

    const tooltipOdds = (trackId: string | null): string => {
        if (trackId === null) return "";
        if (
            segments[$currentSegmentIdx].offence_team ===
            players[$selectedTrackId].team
        )
            return (
                segments[$currentSegmentIdx].offence_odds[
                    players[trackId].jersey_number
                ] || "100 / 1"
            );
        else
            return (
                segments[$currentSegmentIdx].defence_odds[
                    players[trackId].jersey_number
                ] || "100 / 1"
            );
    };

    const tooltipStyle = (
        ts: number | undefined,
        r: DOMRect | null
    ): string => {
        if (r === null) return "--tooltip-visible: hidden;";
        if (
            ts === undefined ||
            ts >= segments[$currentSegmentIdx].startPlay * 1000
        )
            return "--tooltip-visible: hidden;";
        let left = r.x + r.width / 2;
        let top = Math.max(r.y, 80);
        let innerWidth = document.documentElement.clientWidth;
        let left_perc = 50; // for the tooltip arrow
        if (left < 140) {
            left_perc = Math.max(6, ((left / 140) * 100) / 2);
            left = 140;
        }
        if (left > innerWidth - 140) {
            left_perc = Math.min(
                94,
                (((left - innerWidth + 140) / 140) * 100) / 2 + 50
            );
            left = innerWidth - 140;
        }
        return `--tooltip-visible: visible; --tooltip-left: ${left}px; --tooltip-top: ${top}px; --tooltip-arrow-left: ${left_perc}%;`;
    };
</script>

<style>
    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    svg {
        position: absolute;
        margin: 0 auto;
        top: 50%;
        transform: translate(0, -50%);
        z-index: 30;
        max-width: 100%;
        height: 100%;
    }

    .rect {
        fill: rgb(0, 0, 0);
        fill-opacity: 0;
        user-select: none;
        pointer-events: all;
    }

    .rect:hover {
        fill-opacity: 0.3;
        cursor: pointer;
    }
    .selected-rect {
        fill: white;
        fill-opacity: 0.1;
        user-select: none;
    }

    .home_team {
        font-family: "Montserrat", sans-serif;
        font-size: 40px;
        font-weight: bolder;
        fill: #ffffff;
    }

    .away_team {
        font-family: "Montserrat", sans-serif;
        font-size: 40px;
        font-weight: bolder;
        fill: #ffcccb;
    }
    .tooltip {
        border-radius: 4px;
        background-color: #ffffff;
        width: 280px;
        height: 60px;
        left: var(--tooltip-left);
        top: var(--tooltip-top);
        position: absolute;
        transform: translate(-50%, calc(-100% - 10px));
        margin-bottom: 5px;
        padding: 2px;
        box-shadow: 3px 5px 18px #000000;
        font-family: "Montserrat", sans-serif;
        letter-spacing: 0.5px;
        display: flex;
        align-items: center;
        z-index: 30;
        user-select: none;
        visibility: var(--tooltip-visible);
    }

    .tooltip:after {
        content: "";
        position: absolute;

        /* position tooltip correctly */
        left: var(--tooltip-arrow-left);
        margin-bottom: -5px;

        /* vertically center */
        top: 100%;
        transform: translateX(-50%);

        /* the arrow */
        border: 10px solid #000;
        border-color: white transparent transparent transparent;

        display: block;
        animation: fadeOut 1s ease-in-out 0s forwards;
    }

    .mugshot {
        border-radius: 50%;
        display: inline-flex;
        vertical-align: middle;
        width: 74px;
        clip: rect(82px, 0px, 518px, 0px);
    }

    .player-info {
        margin-left: 5px;
        height: 90%;
        max-width: 130px;
        display: inline-flex;
        flex-grow: 1;
        white-space: nowrap;
        align-items: center;
    }

    .player-info-sub {
        display: table;
    }

    .player-name {
        font-weight: bolder;
        color: #000000;
        font-size: small;
        font-weight: bold;
        display: table-row;
        text-transform: uppercase;
    }

    .player-role {
        font-size: x-small;
        font-weight: bold;
        color: #888888;
        display: table-row;
    }

    .betting {
        margin-left: 5px;
        margin-right: 5px;
        white-space: nowrap;
        user-select: none;
        height: 60%;
    }

    .betting-button {
        border: 2px solid #86b122;
        background: linear-gradient(#abd840, #86b11d);
        color: white;
        font-size: small;
        font-weight: bold;
        height: 100%;
        border-radius: 4px;
        text-align: center;
        -webkit-transition-duration: 0.4s; /* Safari */
        transition-duration: 0.4s;
        text-decoration: none;
        overflow: hidden;
        cursor: pointer;
    }
    .betting-button:disabled,
    .betting-button[disabled] {
        background: #5a5a5a;
        border: 2px solid #5a5a5a;
        color: #838383;
        user-select: none;
        cursor: not-allowed;
    }

    .betting-button-selected {
        border: 2px solid #eaeaea;
        background: linear-gradient(#f8f8f8, #f0f0f0);
        color: black;
        font-size: small;
        font-weight: bold;
        height: 100%;
        border-radius: 4px;
        text-align: center;
        -webkit-transition-duration: 0.4s; /* Safari */
        transition-duration: 0.4s;
        text-decoration: none;
        overflow: hidden;
        user-select: none;
    }
</style>

<svelte:window
    on:resize={() => {
        $selectedTrackId = null;
        domRect = null;
    }} />

<svg
    viewBox="0 0 1920 1080"
    preserveAspectRatio="xMinYMid meet"
    on:click={(e) => onPlayerClick(e, null)}>
    <defs>
        <linearGradient id="home_team" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#ffffff" stop-opacity="0" />
            <stop offset="94%" stop-color="#ffffff" stop-opacity="0" />
            <stop offset="100%" stop-color="#ffffff" stop-opacity="0.3" />
        </linearGradient>
        <linearGradient id="away_team" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#a71931" stop-opacity="0" />
            <stop offset="94%" stop-color="#a71931" stop-opacity="0" />
            <stop offset="100%" stop-color="#a71931" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient id="betting" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#32cd32" stop-opacity="0" />
            <stop offset="94%" stop-color="#32cd32" stop-opacity="0" />
            <stop offset="100%" stop-color="#32cd32" stop-opacity="0.5" />
        </linearGradient>
    </defs>
    {#if !$seeking && bboxes}
        {#each Object.entries(players) as [trackId, player]}
            {#if bboxes[trackId] && ((players[trackId].team === segments[$currentSegmentIdx].offence_team && players[trackId].jersey_number in segments[$currentSegmentIdx].offence_odds) || (players[trackId].team !== segments[$currentSegmentIdx].offence_team && players[trackId].jersey_number in segments[$currentSegmentIdx].defence_odds))}
                {#if trackId === currentTrackId}
                    <text
                        x={bboxes[trackId][0] + (bboxes[trackId][2] - bboxes[trackId][0]) / 2}
                        y={bboxes[trackId][1] + (bboxes[trackId][3] - bboxes[trackId][1]) / 2}
                        dominant-baseline="middle"
                        text-anchor="middle"
                        class={player.team}>
                        #{players[trackId].jersey_number}
                    </text>
                {/if}
                <rect
                    out:fade
                    in:fade
                    id={trackId}
                    x={bboxes[trackId][0]}
                    y={bboxes[trackId][1]}
                    width={bboxes[trackId][2] - bboxes[trackId][0]}
                    height={bboxes[trackId][3] - bboxes[trackId][1]}
                    rx="10"
                    ry="10"
                    stroke={!$currentFrameDetection || trackId === currentTrackId || trackId === $selectedTrackId ? '' : trackId === bettingTrackId ? 'url(#betting)' : `url(#${players[trackId].team})`}
                    stroke-width="15"
                    stroke-linecap="round"
                    visibility={$currentFrameDetection.timestamp >= segments[$currentSegmentIdx].startPlay * 1000 && trackId !== bettingTrackId ? 'hidden' : 'visible'}
                    on:mouseenter={() => onMouseEnter(trackId)}
                    on:mouseleave={() => onMouseLeave()}
                    on:click={(e) => onPlayerClick(e, trackId)}
                    class={$selectedTrackId === trackId ? 'selected-rect' : 'rect'} />
            {/if}
        {/each}
    {/if}
</svg>

{#key $selectedTrackId}
    <div
        transition:fly={{ y: 10, duration: 500 }}
        class="tooltip"
        style={tooltipStyle($currentFrameDetection?.timestamp, domRect)}>
        <img class="mugshot" src={tooltipMughostSrc($selectedTrackId)} alt="" />
        <div class="player-info">
            <div class="player-info-sub">
                <p class="player-name">{tooltipPlayerName($selectedTrackId)}</p>
                <p class="player-role">{tooltipMarket($selectedTrackId)}</p>
            </div>
        </div>
        <div class="betting">
            <button
                class={bettingTrackId === $selectedTrackId ? 'betting-button-selected' : 'betting-button'}
                disabled={bettingTrackId !== null}
                on:click={() => onBetClick($selectedTrackId)}><span>{tooltipOdds($selectedTrackId)}</span></button>
        </div>
    </div>
{/key}
